var cifSd = ["301 151", "<g fill='none'><path fill='#D21034' d='M.5.5h300v50H.5z'/><path fill='#FFF' d='M.5 50.5h300v50H.5z'/><path fill='#000' d='M.5 100.5h300v50H.5z'/><path fill='#007229' d='M.5.5l100 75-100 75z'/></g>"];

export { cifSd };
//# sourceMappingURL=cif-sd.js.map
